var _props$data$mounted$m;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import draggable from 'vuedraggable';

export default (_props$data$mounted$m = {

    props: ['website'],
    data: function data() {
        return {
            newHeroSlide: {
                image: null,
                sectionTitle: 'New hero slide',
                subtitle: '',
                btn_1_text: '',
                btn_2_text: '',
                video_url: '',
                form: null,
                toggleMediaGallery: false
            },
            hero: [{
                image: null,
                sectionTitle: 'Hero 1 - Sample',
                subTitle: '',
                buttonOneText: '',
                buttonTwoText: '',
                form: null
            }, {
                image: null,
                sectionTitle: 'Hero 2 - Sample',
                subTitle: '',
                buttonOneText: '',
                buttonTwoText: ''
            }],
            intro: {
                id: 0,
                title_first_word: '',
                title_second_word: '',
                intro_text: '',
                image: null,
                url: null
            },
            featured: {
                image: null,
                url: null
            },
            featuredImages: {},
            asmartment: {
                showAsmartment: false
            },
            gallery: {
                showGallery: true,
                galleryType: 'full'
            },
            amenitiesList: [],
            selectedAmenities: [],
            showFullGallery: false,
            positionLabels: {
                'top': 'Top',
                'bottom-left': 'Bottom Left',
                'bottom-middle': 'Bottom Right'
            }
        };
    },
    mounted: function mounted() {
        Event.$on('save-page-amenities', function () {
            $el.refresh();
        });
    },

    methods: {
        deploySite: function deploySite() {
            Event.$emit('deploy-site');
        },
        getAmenities: function getAmenities() {

            var self = this;

            axios.get('/prototype/website-amenity').then(function (response) {
                self.amenitiesList = Object.values(response.data);
                self.amenitiesList.sort(function (a, b) {
                    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
                //self.selectedAmenities = self.website.amenities
                if (self.website.amenities.length) {
                    for (var i = 0; i < self.website.amenities.length; i++) {
                        var amenity = self.website.amenities[i];
                        delete amenity.pivot;
                        self.addAmenity(amenity);
                    }
                }
            });
        },
        addAmenity: function addAmenity(amenity) {
            if (this.selectedAmenities.includes(amenity)) {} else {
                var found = false;
                if (this.selectedAmenities.length) {
                    for (var i = 0; i < this.selectedAmenities.length; i++) {
                        if (this.selectedAmenities[i]['id'] == amenity.id) {
                            found = true;
                        }
                    }
                }
                if (!found) {
                    this.selectedAmenities.push(amenity);
                }
            }
        },
        removeAmenity: function removeAmenity(idx) {
            this.selectedAmenities.splice(idx, 1);
        },
        strikethrough: function strikethrough(amenity) {
            if (this.selectedAmenities.length) {
                for (var i = 0; i < this.selectedAmenities.length; i++) {
                    if (this.selectedAmenities[i]['id'] == amenity.id) {
                        return true;
                    }
                }
            }
        },
        savePageAmenities: function savePageAmenities() {
            var _this = this;

            var self = this;

            var sendData = {
                id: this.website.id,
                // property_id: this.website.property_id,
                amenities: this.selectedAmenities
            };

            axios.post('/prototype/website/' + this.website.id + '/amenities', sendData).then(function (response) {
                if (response.data) {

                    self.amenities = response.data.amenities;

                    _this.$snotify.success('Website amenities were updated');

                    Event.$emit('refresh-property-website', self.website.property_id);
                }
            });

            var data = self.website;
            var gallery = self.website.amenities_hero_image_gallery.photos;
            var test = [];
            test.append = { test: '1234' };
            data.test = test;
            data.gallery = [];
            if (gallery.length) {
                data.gallery['amenities_hero_images'] = [];
                for (var i = 0; i < gallery.length; i++) {
                    data.gallery['amenities_hero_images'].push({
                        id: gallery[i].id,
                        image: gallery[i].image,
                        section_title: gallery[i].meta.section_title,
                        subtitle: gallery[i].meta.subtitle,
                        btn_1_text: gallery[i].meta.btn_1_text,
                        btn_2_text: gallery[i].meta.btn_2_text,
                        video_url: gallery[i].meta.video_url
                    });
                }
            }

            var $el = this;
            var fd = new FormData();

            fd.append('amenities_data', 1);
            fd.append('amenities_hero_headline', $el.website.amenities_hero_headline);
            fd.append('amenities_hero_byline', $el.website.amenities_hero_byline);
            fd.append('amenities_hero_video_url', $el.website.amenities_hero_video_url);
            fd.append('amenities_intro_text', $el.website.amenities_intro_text);
            fd.append('amenities_has_asmartment', 0);
            if ($el.website.amenities_has_asmartment || $el.website.amenities_has_asmartment == 'true') {
                fd.append('amenities_has_asmartment', 1);
            }
            fd.append('amenities_show_full_gallery', 0);
            if ($el.showFullGallery) {
                fd.append('amenities_show_full_gallery', 1);
            }
            fd.append('amenities_description', $el.website.amenities_description);
            fd.append('amenities_page_gallery_type', $el.website.amenities_page_gallery_type);
            fd.append('amenities_gallery_left_label', $el.website.amenities_gallery_left_label);
            fd.append('amenities_gallery_right_label', $el.website.amenities_gallery_right_label);

            var gallery = $el.website.amenities_hero_image_gallery.photos;
            if (gallery.length) {
                for (var i = 0; i < gallery.length; i++) {
                    fd.append('gallery[amenities_hero_images][' + i + '][id]', gallery[i].id);
                    fd.append('gallery[amenities_hero_images][' + i + '][image]', gallery[i].image);
                    fd.append('gallery[amenities_hero_images][' + i + '][main_title]', gallery[i].meta.main_title);
                    fd.append('gallery[amenities_hero_images][' + i + '][subtitle]', gallery[i].meta.subtitle);
                }
            }

            var gallery = $el.website.amenities_featured_image_gallery.photos;
            if (gallery.length) {
                for (var i = 0; i < gallery.length; i++) {
                    fd.append('gallery[amenities_featured_images][' + i + '][id]', gallery[i].id);
                    fd.append('gallery[amenities_featured_images][' + i + '][image]', gallery[i].image);
                    fd.append('gallery[amenities_featured_images][' + i + '][position]', gallery[i].meta.position);
                }
            }

            var gallery = $el.website.amenities_footer_featured_image_gallery.photos;
            if (gallery.length) {
                for (var i = 0; i < gallery.length; i++) {
                    fd.append('gallery[amenities_footer_featured_images][' + i + '][id]', gallery[i].id);
                    fd.append('gallery[amenities_footer_featured_images][' + i + '][image]', gallery[i].image);
                }
            }

            axios.post('/prototype/website/' + self.website.id, fd).then(function (response) {
                if (response.data.error) {
                    _this.$snotify.error('Error saving website data: ' + response.data.error);
                } else {
                    _this.$snotify.success('Website data was updated');
                    Event.$emit('refresh-property-website', self.website.property_id);
                }
            });
        }
    }
}, _defineProperty(_props$data$mounted$m, 'mounted', function mounted() {
    this.getAmenities();

    if (this.website) {

        if (this.website.amenities_show_full_gallery == 1) {
            this.showFullGallery = true;
        } else {
            this.showFullGallery = false;
        }
    }
}), _defineProperty(_props$data$mounted$m, 'watch', {
    selectedFloorplan: function selectedFloorplan(newVal, oldVal) {}
}), _props$data$mounted$m);


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/pages/PageAmenities.vue
// module id = rtmC
// module chunks = 0 1